/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type IconIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function IconIcon(props: IconIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 28 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M17.39 22.75q-3.666 0-6.21-2.544t-2.545-6.211q0-3.639 2.544-6.192 2.546-2.553 6.21-2.553 3.64 0 6.192 2.553 2.554 2.553 2.554 6.192 0 3.666-2.554 6.21-2.552 2.545-6.191 2.545M17.385 21q2.916 0 4.958-2.042T24.385 14t-2.042-4.958T17.385 7t-4.959 2.042q-2.04 2.041-2.041 4.958 0 2.916 2.042 4.958Q14.467 21 17.385 21m2.766-2.957 1.248-1.247-3.14-3.14V9.514h-1.75v4.86zM3.026 10.208v-1.75h4.442v1.75zm-1.167 4.667v-1.75h5.61v1.75zm1.167 4.667v-1.75h4.442v1.75z"
        }
      ></path>
    </svg>
  );
}

export default IconIcon;
/* prettier-ignore-end */
